import React from 'react'

import DropdownMenu from 'old-code/components/DropdownMenu/DropdownMenu'
import usePostHog from 'old-code/customHooks/usePostHog'

const BroadcastManagerDraftRowEdit = ({
  data,
  showTaskCreate,
  onDeleteBroadcast,
  showTaskInfo,
  dropdownRef,
}) => {
  const logPostHogEvent = usePostHog()
  const editAction = [
    {
      id: 'editBroadcast',
      label: 'Edit Broadcast',
      showTaskInfo,
      onClick: () => showTaskCreate(data),
    },
    {
      id: 'deleteBroadcast',
      label: 'Delete Broadcast',
      showTaskInfo,
      color: 'red',
      divider: true,
      onClick: () => onDeleteBroadcast(data),
    },
  ]

  return (
    <DropdownMenu
      fontWeight="normal"
      actions={editAction}
      dropdownRef={dropdownRef}
      logPostHogEvent={logPostHogEvent}
      postHogModule="broadcasts"
    />
  )
}

export default BroadcastManagerDraftRowEdit
